import FormPontoVenda from "components/FormPontoVenda";

const CriarPontoVenda = () => (
  <div className="card">
    <FormPontoVenda />
  </div>
);

export default CriarPontoVenda;
